import { render, staticRenderFns } from "./my-marker.vue?vue&type=template&id=899c993e&scoped=true"
import script from "./my-marker.vue?vue&type=script&lang=js"
export * from "./my-marker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899c993e",
  null
  
)

export default component.exports